<template>
<div class="data-wrapper" :class="{
  'has-header': !!$slots.header
}">
  <div
    v-if="!!$slots.header"
    class="data-wrapper-header"
  >
    <slot name="header" />
  </div>

  <div class="data-wrapper-body">
    <slot />
  </div>
</div>
</template>

<script>
export default {
  name: 'DataWrapper'
}
</script>

<style lang="scss" scoped>
.data-wrapper {
  display: grid;
  grid-template-rows: auto;
  grid-row-gap: 12px;
  width: 100%;
  height: 100%;

  &.has-header {
    grid-template-rows: max-content auto;
  }

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .data-wrapper-header {
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
    height: 32px;
    text-align: center;
  }

  > .data-wrapper-body {
    display: flex;
    flex-direction: column;
    gap: 22px;
    padding: 0 12px 12px 12px;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/DataWrapper.vue